import { Popover, PopoverContent } from "@/components/ui/popover";
import {
  Checkbox,
  CheckboxField,
  CheckboxGroup,
} from "@/components/catalyst/checkbox";
import { Fieldset, Label } from "@/components/catalyst/fieldset";
import { ReactNode } from "react";
import { TableFilterButton } from "@/lib/Components/DataTable/Filters/TableFilterButton";

export type MultiSelectFilterOption<T extends string> = {
  label: string;
  value: T;
};

export function MultiSelectFilter<T extends string>({
  options,
  onChange,
  selected,
  label,
}: {
  options: MultiSelectFilterOption<T>[];
  onChange: (values: T[]) => void;
  selected: T[];
  label: ReactNode;
}) {
  const numSelected = Object.values(selected).filter((v) => v).length;

  const labels = selected
    .map((key) => {
      const option = options.find((option) => option.value === key);
      return option?.label;
    })
    .filter(Boolean);

  const selectedLabel =
    numSelected > 2
      ? `${labels[0]} and ${numSelected - 1} more`
      : labels.join(", ");

  return (
    <Popover>
      <TableFilterButton
        label={label}
        selectedLabel={selectedLabel}
        numSelected={numSelected}
        onClear={() => {
          onChange([]);
        }}
      />
      <PopoverContent align="start">
        <Fieldset>
          <CheckboxGroup>
            {options.map(({ label, value }) => (
              <CheckboxField key={value}>
                <Checkbox
                  color="indigo"
                  name={`status-${value}`}
                  className="bg-gray-200 hover:bg-gray-200"
                  checked={selected.includes(value)}
                  onChange={(checked) => {
                    onChange(
                      checked
                        ? [...selected, value]
                        : selected.filter((v) => v !== value),
                    );
                  }}
                />
                <Label>{label}</Label>
              </CheckboxField>
            ))}
          </CheckboxGroup>
        </Fieldset>
      </PopoverContent>
    </Popover>
  );
}
